var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("testimonialController", [
    "$scope",
    "testimonialService",
    "$sce",
    "loaderService",
    "$location",
    "modalService",
    "commonService",
    "$rootScope",
    "validationService",
    "$document",
    "$window",
    function (
        $scope,
        testimonialService,
        $sce,
        loaderService,
        location,
        modalService,
        commonService,
        $rootscope,
        validationService,
        $document,
        $window
    ) {
        $scope.initialize = function () {
            $scope.pg = "1";
            $scope.ipp = "20";
            $scope.getTestimonies();
        };

        $scope.getTestimonies = function () {
            loaderService.show();

            testimonialService.getTestimonials().then(
                function (response) {
                    $scope.alltestimonies = response.data;
                    $scope.filterTestimonies("all");
                    loaderService.hide();
                },
                function (response) {
                    loaderService.hide();
                }
            );
        };

        $scope.filterTestimonies = function (filter) {
            $scope.pg = "1";
            $scope.page = 1;

            if (filter.toLowerCase() == "all") {
                $scope.testimoniesFiltered = $scope.alltestimonies;
            } else if (filter.toLowerCase() == "website") {
                $scope.testimoniesFiltered = $scope.alltestimonies.filter(
                    function (x) {
                        return x.isTypeCD == false || x.isTypeCD == null;
                    }
                );
            } else if (filter.toLowerCase() == "cd") {
                $scope.testimoniesFiltered = $scope.alltestimonies.filter(
                    function (x) {
                        return x.isTypeCD == true;
                    }
                );
            }

            var elements = document.getElementsByName("filterButtons");

            angular.forEach(elements, function (el) {
                el.classList.remove("active");
            });

            document.getElementById(filter).classList.add("active");

            $scope.getPagesCount();
        };

        $scope.openForm = function () {
            $scope.initializeModal();

            modalService.open("testimonialModal");
        };

        $scope.closeModal = function (id) {
            $scope.hasError = false;

            modalService.close(id);
        };

        $scope.getCountryRegions = function () {
            var country = $scope.countriesOrig.filter(function (x) {
                return (
                    x.name.toLowerCase() ==
                    $rootscope.testimonialForm.country.toLowerCase()
                );
            });

            if (country && country.length > 0 && country[0].code2) {
                var countryCode = country[0].code2.toLowerCase();

                commonService
                    .getCountryRegions(countryCode)
                    .then(function (response) {
                        $scope.regions = (response && response.data) || [];

                        $rootscope.testimonialForm.state =
                            $scope.regions[0].name;
                    });
            }
        };

        $scope.initializeModal = function () {
            $rootscope.testimonialForm = {
                firstName: "",
                lastName: "",
                phoneNumber: "",
                company: "",
                email: "",
                country: "",
                state: "",
                city: "",
                comment: "",
            };

            commonService.getCountries().then(function (response) {
                $scope.countriesOrig = (response && response.data) || [];

                $rootscope.testimonialForm.country =
                    $scope.countriesOrig[0].name;

                $scope.getCountryRegions();
            });
        };

        $scope.submitForm = function () {
            $scope.hasError = false;

            if (
                $rootscope.testimonialForm.firstName == "" ||
                $rootscope.testimonialForm.lastName == "" ||
                $rootscope.testimonialForm.email == "" ||
                !validationService
                    .getRegularExpressions()
                    .email.test($rootscope.testimonialForm.email) ||
                $rootscope.testimonialForm.country == "" ||
                $rootscope.testimonialForm.state == "" ||
                $rootscope.testimonialForm.city == "" ||
                $rootscope.testimonialForm.comment == ""
            ) {
                $scope.hasError = true;
            } else {
                $scope.hasError = false;
            }

            if (
                $rootscope.testimonialForm.phoneNumber != "" &&
                !validationService
                    .getRegularExpressions()
                    .phone.test($rootscope.testimonialForm.phoneNumber)
            ) {
                $scope.hasError = true;
            }

            if (!$scope.hasError) {
                var object = {
                    name:
                        $rootscope.testimonialForm.firstName +
                        " " +
                        $rootscope.testimonialForm.lastName,
                    country: $rootscope.testimonialForm.country,
                    state: $rootscope.testimonialForm.state,
                    city: $rootscope.testimonialForm.city,
                    testimonial: $rootscope.testimonialForm.comment,
                    email: $rootscope.testimonialForm.email,
                    companyName: $rootscope.testimonialForm.company,
                    isApproved: false,
                    isTypeCd: 0,
                };

                var form_data = new FormData();
                form_data.append("testimonial", angular.toJson(object));
                form_data.append(
                    "g-Recaptcha-Response",
                    $scope.recaptchaResponse
                );

                loaderService.show();
                testimonialService
                    .insertTestimonial(form_data)
                    .then(function (response) {
                        if (response.data) {
                            $rootscope.title = "Success";
                            $rootscope.result =
                                "Your testimony has been submitted for approval.";
                            modalService.close("testimonialModal");
                        } else {
                            $rootscope.title = "Error";
                            $rootscope.result =
                                "Unable to submit your testimony. Please contact an admin.";
                        }

                        modalService.open("resultModal");
                        loaderService.hide();
                    });
            }
        };

        $scope.loadPagination = function () {
            if (document.getElementById("pagination") != null) {
                pagination.Init(document.getElementById("pagination"), {
                    size: $scope.pages,
                    page: Number($scope.pg),
                    step: 2,
                });
            }
        };

        $scope.pages = 1;

        $scope.getPagesCount = function () {
            if (angular.isDefined($scope.testimoniesFiltered)) {
                var count = $scope.testimoniesFiltered.length;
                $scope.pages =
                    count % $scope.ipp > 0
                        ? Math.floor(count / $scope.ipp) + 1
                        : count / $scope.ipp;

                if ($scope.pg > $scope.pages) {
                    $scope.pg = $scope.pages;
                }

                $scope.testimonies = $scope.testimoniesFiltered.slice(
                    0,
                    Number($scope.ipp)
                );

                $scope.changePage(1);
                setTimeout(function () {
                    $scope.loadPagination();
                }, 400);
            }
        };

        $scope.changePage = function (requestedPage) {
            if (requestedPage != "prev" && requestedPage != "next") {
                pagination.page = Number(requestedPage);
                $scope.pg =
                    requestedPage != null ? requestedPage.toString() : "1";
            } else if (requestedPage == "prev") {
                pagination.page = Number($scope.pg) - 1;
                $scope.pg = (Number($scope.pg) - 1).toString();
            } else if (requestedPage == "next") {
                pagination.page = Number($scope.pg) + 1;
                $scope.pg = (Number($scope.pg) + 1).toString();
            }

            $window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });

            var start = (Number($scope.pg) - 1) * Number($scope.ipp);
            var end = Number($scope.pg) * Number($scope.ipp);

            $scope.testimonies = $scope.testimoniesFiltered.slice(start, end);
        };

        $scope.ippChange = function () {
            $scope.getPagesCount();
        };

        var pagination = {
            code: "",
            Extend: function (data) {
                data = data || {};
                pagination.size = data.size || 1;
                pagination.page = data.page || 1;
                pagination.step = data.step || 2;
            },

            Add: function (first, last) {
                for (var i = first; i < last; i++) {
                    pagination.code += "<a class='flex center'>" + i + "</a>";
                }
            },

            Last: function () {
                pagination.code +=
                    '<i class="flex center">...</i><a class="flex center">' +
                    pagination.size +
                    "</a>";
            },

            First: function () {
                pagination.code +=
                    '<a class="flex center">1</a><i class="flex center">...</i>';
            },

            Click: function () {
                var requestedPage = +this.innerHTML;
                $scope.changePage(requestedPage);
                $scope.$apply();
                pagination.Start();
            },

            Prev: function () {
                pagination.page--;
                if (pagination.page < 1) {
                    pagination.page = 1;
                }
                $scope.changePage(pagination.page);
                $scope.$apply();
                pagination.Start();
            },

            Next: function () {
                pagination.page++;
                if (pagination.page > pagination.size) {
                    pagination.page = pagination.size;
                }
                $scope.changePage(pagination.page);
                $scope.$apply();
                pagination.Start();
            },

            Bind: function () {
                var prev = $document[0].getElementById("prev");
                var next = $document[0].getElementById("next");
                if ($scope.pg == "1") {
                    prev.classList.add("disabled");
                } else {
                    prev.classList.remove("disabled");
                }
                if ($scope.pg == $scope.pages) {
                    next.classList.add("disabled");
                } else {
                    next.classList.remove("disabled");
                }

                var a = pagination.e.getElementsByTagName("a");
                for (var i = 0; i < a.length; i++) {
                    if (+a[i].innerHTML === pagination.page) {
                        a[i].classList.add("active");
                    }
                    a[i].addEventListener("click", pagination.Click, false);
                }
            },

            Finish: function () {
                pagination.e.innerHTML = pagination.code;
                pagination.code = "";
                pagination.Bind();
            },

            Start: function () {
                if (pagination.size < pagination.step * 2 + 6) {
                    pagination.Add(1, pagination.size + 1);
                } else if (pagination.page < pagination.step * 2 + 1) {
                    pagination.Add(1, pagination.step * 2 + 4);
                    pagination.Last();
                } else if (
                    pagination.page >
                    pagination.size - pagination.step * 2
                ) {
                    pagination.First();
                    pagination.Add(
                        pagination.size - pagination.step * 2 - 2,
                        pagination.size + 1
                    );
                } else {
                    pagination.First();
                    pagination.Add(
                        pagination.page - pagination.step,
                        pagination.page + pagination.step + 1
                    );
                    pagination.Last();
                }
                pagination.Finish();
            },

            Buttons: function (e) {
                var nav = e.getElementsByTagName("a");
                nav[0].addEventListener("click", pagination.Prev, false);
                nav[1].addEventListener("click", pagination.Next, false);
            },

            Create: function (e) {
                if (angular.isDefined(e)) {
                    var html = [
                        '<div id="prev" class="prev"><a class="flex center"><i class="fa fa-angle-left"></i></a></div>',
                        '<span class="flex row"></span>',
                        '<div id="next" class="next"><a class="flex center"><i class="fa fa-angle-right"></i></a></div>',
                    ];
                    e.innerHTML = html.join("");
                    pagination.e = e.getElementsByTagName("span")[0];
                    pagination.Buttons(e);
                }
            },

            Init: function (e, data) {
                pagination.Extend(data);
                pagination.Create(e);
                pagination.Start();
            },
        };
    },
]);
